/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Faq_4_AnswerInputs */

const en_svc_research_faq_4_answer = /** @type {(inputs: Svc_Research_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our own content engine researches and fact-checks every article we publish, citing each source. The case study shows how it works.`)
};

const lv_svc_research_faq_4_answer = /** @type {(inputs: Svc_Research_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mūsu satura sistēma izpēta un pārbauda katru publicēto rakstu un norāda katru avotu. Gadījuma izpētē redzams, kā tā darbojas.`)
};

/**
* | output |
* | --- |
* | "Our own content engine researches and fact-checks every article we publish, citing each source. The case study shows how it works." |
*
* @param {Svc_Research_Faq_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_faq_4_answer = /** @type {((inputs?: Svc_Research_Faq_4_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Faq_4_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_faq_4_answer(inputs)
	return en_svc_research_faq_4_answer(inputs)
});